import { useEffect, useState } from "react";
import * as api from "../../api";

const num = n => String(Math.round(Number(n))).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
const MODO = { manual: "Manual", auto: "Automático" };

// «Mis listas de Notion» (T-144): las listas ya elegidas, con su modo, y quitar una contando antes que pasa con sus tareas.
// onOtra(): elegir otra base. onCerrar(): cerrar el dialogo. onCambio(): hay que recargar Tareas.
export default function ListasNotion({ listas, onOtra, onCerrar, onCambio, showToast, onQuitada }) {
  const [quitando, setQuitando] = useState(null);     // { lista, previa|null, error }
  const [ocupada, setOcupada] = useState(false);

  useEffect(() => {
    if (!quitando || quitando.previa || quitando.error) return undefined;
    let vivo = true;
    api.quitarPreviaFuenteNotion(quitando.lista.id)
      .then(p => { if (vivo) setQuitando(q => (q ? { ...q, previa: p } : q)); })
      .catch(e => { if (vivo) setQuitando(q => (q ? { ...q, error: e?.message || "No se ha podido calcular" } : q)); });
    return () => { vivo = false; };
  }, [quitando]);

  const quitar = async retirar => {
    setOcupada(true);
    try {
      const r = await api.quitarFuenteNotion(quitando.lista.id, { retirar });
      showToast?.(r.retiradas > 0 ? `Lista quitada: se retiran ${num(r.retiradas)} tareas que no habías tocado` : "Lista quitada: tus tareas se conservan");
      setQuitando(null); onQuitada?.(quitando.lista.id); onCambio?.();
    } catch (e) {
      setQuitando(q => ({ ...q, error: e?.message || "No se ha podido quitar la lista" }));
    } finally { setOcupada(false); }
  };

  if (quitando) {
    const p = quitando.previa;
    const m = p ? Math.max(0, (p.traidas || 0) - (p.auto_sin_tocar || 0)) : 0;
    return (
      <div className="fn" role="group" aria-label={`Quitar «${quitando.lista.nombre}»`}>
        <p className="fn-cuenta"><b>Quitar «{quitando.lista.nombre}»</b></p>
        {quitando.error ? (
          <div className="ex-aviso ex-err" role="alert"><b>{quitando.error}.</b> No se ha cambiado nada.</div>
        ) : !p ? (
          <p className="mt-sel-nota" role="status">Contando tus tareas de esta lista…</p>
        ) : (
          <>
            <p>Dejaré de traer tareas de esta base.{" "}
              {p.auto_sin_tocar > 0
                ? <><b>Se conservan {num(m)} {m === 1 ? "tarea" : "tareas"}</b> (las que ya has planificado, hecho o aplazado); <b>se retiran {num(p.auto_sin_tocar)}</b> que no habías tocado.</>
                : <b>Tus {num(p.traidas || 0)} tareas se quedan en Tareas.</b>}</p>
            <p className="fn-nota">Si más adelante vuelves a elegir esta base, no se duplicará nada.</p>
          </>
        )}
        <div className="mt-dlg-pie">
          <button type="button" className="mt-b btn" disabled={ocupada} onClick={() => setQuitando(null)}>Cancelar</button>
          {p && p.auto_sin_tocar > 0 && <button type="button" className="mt-b btn" disabled={ocupada} onClick={() => quitar(false)}>Quitar y conservar todo</button>}
          {p && <button type="button" className="mt-b nv-no btn" disabled={ocupada} onClick={() => quitar(p.auto_sin_tocar > 0)}>Quitar la lista</button>}
        </div>
      </div>
    );
  }

  return (
    <div className="fn">
      {listas.map(l => (
        <div className="nv-card" key={l.id}>
          <div className="fn-cab">
            <b>{l.nombre}</b>
            <small>{MODO[l.modo] || l.modo}{l.base ? ` · ${num(l.base.filas)} filas` : ""}</small>
            <button type="button" className="mt-b nv-no btn" aria-label={`Quitar la lista ${l.nombre}`} onClick={() => setQuitando({ lista: l, previa: null, error: null })}>Quitar</button>
          </div>
        </div>
      ))}
      <div className="mt-dlg-pie">
        <button type="button" className="mt-b btn" onClick={onCerrar}>Cerrar</button>
        <button type="button" className="mt-b p btn" onClick={onOtra}>Añadir otra lista</button>
      </div>
    </div>
  );
}
